import { fillArrayWithNumber } from 'utils/dataTypes/array';

export enum TASK_STATUS {
  DONE = 'DONE',
  PENDING = 'PENDING',
}

export enum TASK_MANAGEMENT_TYPE {
  GROUP = 'group',
  PERMISSION = 'permission',
}

export const TaskStatusConfig: Record<
  TASK_STATUS,
  { label: string; color: string }
> = {
  [TASK_STATUS.DONE]: {
    label: 'Đã hoàn thành',
    color: 'green',
  },
  [TASK_STATUS.PENDING]: {
    label: 'Chưa hoàn thành',
    color: 'red',
  },
};

export const tableData = fillArrayWithNumber(10).map(item => ({
  id: item,
  department: 'Phòng Kinh doanh & Đầu tư',
  taskName: 'Huy động vốn',
  note: 'Huy động vốn',
  assignedDate: '16/06/2025',
  completedDate: '19/06/2025',
  status: item % 2 === 0 ? TASK_STATUS.PENDING : TASK_STATUS.DONE,
  linkedDocument: '19/06/2025',
  attachment: '19/06/2025',
  resultContent: '19/06/2025',
  recommendation: '19/06/2025',
  otherDocument: '19/06/2025',
}));

export const taskOversightTableData = fillArrayWithNumber(10).map(item => ({
  id: item,
  department: 'Phòng Tài chính kế toán',
  assignedDate: '16/06/2025',
  result: {
    complete: 7,
    incomplete: 8,
  },
  note: '',
}));
